import { useCallback } from "react";
import { useI18n } from "@bookingcom/lingojs-react";
import capitalize from "lodash/capitalize";
import { formattingUtils } from "@flights/web-api-utils-universal";
export default function useCabinClassName() {
    const i18n = useI18n();
    const getCabinClassName = useCallback((cabinClass = "") => {
        const mappedClassName = formattingUtils.getCabinClassName(cabinClass);
        return !!mappedClassName ? i18n.trans(mappedClassName) : capitalize(cabinClass);
    }, [i18n]);
    return getCabinClassName;
}
